module.exports = __webpack_public_path__ + "static/img/showroomTop.c8778fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/showroomTop.png
// module id = GYJ1
// module chunks = 2